import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import split from 'lodash/split';
/**
 * 判断是否是空对象
 *
 * @export
 * @param {any} obj
 * @returns
 */
export function isObjectEmpty(obj) {
  return isEmpty(obj);
}

/**
 * 获取字符串字符长度
 *
 * @export
 * @param {any} str
 * @returns
 */
export function getStrLength(str) {
  let len = 0;
  const string = str || '';
  const length = string ? string.length : 0;
  for (let i = 0; i < length; i++) {
    // 判断中文
    if (string.charCodeAt(i) > 255) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
}

/**
 * 判断数据对象是不是有礼派的错误数据结构
 *
 * @export
 * @param {any} obj
 * @returns
 */
export function isYlpErrorObject(obj) {
  return !isEmpty(obj) && has(obj, 'code') && has(obj, 'msg') && !isNil(obj.code) && obj.code != 0;
}


/**
 * 休眠， 用于调试
 *
 * @export
 * @param {any} time
 * @returns
 */
export async function sleep(time){
  return await new Promise((resolve)=>{
    setTimeout(()=> resolve(true), time)
  })
}


/**
 * 解析链接
 * @param href
 * @returns {{href: *, protocol, host, hostname, port, pathname, search, hash}}
 */
export function url(href) {
  // eslint-disable-next-line
  const match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  }
}

/**
 * 文字隐藏
 * @param {string} txt - 要处理的文字
 * @param {number} startIndex - 开始隐藏的位置
 * @param {number} endIndex - 结束隐藏的位置
 * @param {string} symbol - 代替的符合
 * @param {number} symbolCount - 隐藏符号的数量
 */
export function hideText(txt, startIndex = 1, endIndex = 0, symbol="*", symbolCount) {
	const len = txt.length;
	return typeof txt !== 'string' || len === 1 || startIndex >= len || startIndex + endIndex >= len
		? txt
		: `${txt.slice(0, startIndex)}${''.padEnd(symbolCount || len - startIndex - endIndex, symbol)}${txt.slice(len - endIndex)}`;
}
/**
 * 格式化价格
 **/
export function formatPrice(price) {
  // return price ? price.split(/\D+/img).filter(item => item) : [];
  return price ? price.split(/-+/img).map(item => item.split(/\D+/img).filter(item => item)) : [[],[]];
}

// function matchMoney(money){
//   var arr=["￥","¥","$","€","R$","￡"];
//   var result=false;
//   for(var k in arr){
//     if(money && money.indexOf(arr[k])==0){
//       result=true;
//       break;
//     }
//   }
//   return result;
// }
// 价格首位不是数字是￥去除首位
// export function delFirstChar(str) {
//   if (!str) return '';
//   var result;
//   if(matchMoney(str)){
//     result=str.substring(1);
//   }else{
//     result=str;
//   }
//   return result
// }

// 匹配价格示例：var str="￥12342.5-￥5.89"; var result=matchMoney(str); 输出12342.5-5.89
export function delFirstChar(money){
  var arr=["￥","¥"];
  var result = money;
  for(var k in arr){
    if(money && money.indexOf(arr[k])> -1){
      //result=str.replace(arr[k],””);
      result=result.replace(new RegExp(arr[k],"gm"),"");
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/Help.js